import { component } from 'picoapp'
import Flickity from 'flickity'

class FeaturedCarousel {
  constructor(node, ctx) {
    // bindings

    // selectors
    this._node = node
    this._featured_carousel = this._node.querySelector('.featured-carousel')
    this._carousel = new Flickity(this._featured_carousel, {
      pageDots: false,
      prevNextButtons: false,
      percentPosition: true,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: true,
      pauseAutoPlayOnHover: false
    })

    // events
    this._carousel.on('dragStart', () => this._featured_carousel.classList.add('dragula'))
    this._carousel.on('dragEnd', () => this._featured_carousel.classList.remove('dragula'))
    this._carousel.viewport.style.touchAction = "pan-y pinch-zoom"

    setTimeout(() => {
      this._carousel.resize()
    }, 0)

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Unmount.
  //
  unmount() {
    // events
  }
}

export default component((node, ctx) => new FeaturedCarousel(node, ctx))
